import { render, staticRenderFns } from "./DimensionItemDelete.vue?vue&type=template&id=60a98802"
import script from "./DimensionItemDelete.vue?vue&type=script&lang=js"
export * from "./DimensionItemDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports